import React, { Fragment, useEffect, useState } from 'react';
import Navbar from '../../../components/Navbar';
import { Button, Col, Form, FormCheck, Row, Spinner, Toast } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
  approvalStaff,
  budgetAccounts,
  capitalBudgetAccounts,
  impactedOperatingBudgets,
  locations,
  operatingBudgetAccounts,
  PO,
  supportStaff,
} from '../utils';

import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { useSelector } from 'react-redux';
import Axios from 'axios';
import { stringify } from 'querystring';
import { useMutation } from '@apollo/client';
import { createAuditMutation, updatePurchaseOrder } from '../api';
import { NewAttachment } from '../components/NewAttachment';
import { AttachmentList } from '../components/AttachmentList';
import { Tooltip } from '../../../components/Tooltip';
import { Comments } from '../../../components/Comments';
import { NumericFormat } from 'react-number-format';
import { purchaseOrderApprovalEmail } from '../../../../../backend/src/utils/emailUtil';

interface Props {
  data: any;
}

export const EditPurchaseOrderForm = (props: Props) => {
  const { user } = useSelector((state: any) => ({
    user: state.user,
  }));
  const [files, setFiles] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [comment, setComment] = useState('');
  const [updatePO] = useMutation(updatePurchaseOrder);
  const [createAudit] = useMutation(createAuditMutation);
  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    getValues,

    formState: { errors, dirtyFields },
  } = useForm<PO>({
    defaultValues: {
      ...props.data,
      renewal: props.data.renewal,
      location: props.data.location ? [props.data.location] : [],
      impactedOperatingBudget: props.data.impactedOperatingBudget
        ? props.data.impactedOperatingBudget.includes(',')
          ? props.data.impactedOperatingBudget.split(',')
          : [props.data.impactedOperatingBudget]
        : [],
      capitalBudgetAccountNo: props.data.capitalBudgetAccountNo ? [props.data.capitalBudgetAccountNo] : [],
      budgetAccountNo: props.data.budgetAccountNo ? [props.data.budgetAccountNo] : [],
      supportStaff: props.data.supportStaff,
    },
  });

  const onSubmit = handleSubmit(async (values: PO) => {
    try {
      values.location = values.location[0];
      values.capitalBudgetAccountNo = values.capitalBudgetAccountNo.length === 0 ? null : values.capitalBudgetAccountNo[0];
      values.budgetAccountNo = values.budgetAccountNo.length === 0 ? null : values.budgetAccountNo[0];
      switch (values.impactedOperatingBudget.length) {
        case 0:
          values.impactedOperatingBudget = null;
          break;
        case 1:
          values.impactedOperatingBudget = values.impactedOperatingBudget[0];
          break;
        default:
          values.impactedOperatingBudget = values.impactedOperatingBudget.join(', ');
      }
      // values.supportStaff = values.supportStaff[0].email
      setSubmit(true);

      updatePO({ variables: values })
        .then((res) => createPOAudit(values))
        .then((res) => {
          setToastVisible(true);
          setSubmit(false);

          setTimeout(() => {
            window.location.reload();
          }, 2000);
        })
        .catch((err) => {
          console.log('axios post err: ', err);
        });

      console.log(`current: ${props.data.status} changeTo: ${values.status}`);
      setSubmit(false);
    } catch (err) {
      alert('Error: /frontend/src/pages/PurchaseOrders/CreatePurchaseOrder/index//onSubmit');
      setSubmit(false);
    }
  });

  const isAdmin = () => {
    return user.roles.some((item) => {
      return item.roleName === 'PO Admin' || item.roleName === 'PO Support';
    });
  };

  const createPOAudit = (formValues) => {
    let commentStr = comment !== '' ? comment : 'PO has been updated';
    const audit = {
      createdBy: user?.adId ?? '',
      lastUpdatedBy: user?.adId ?? '',
      comment: commentStr,
      updatedOn: new Date(),
      entryType: 'Purchase Order',
      poId: formValues.id,
    };
    createAudit({ variables: audit }).catch((err) =>
      console.log('Error: /frontend/src/pages/PurchaseOrder/EditPurchaseOrderForm//createPOAudit', err)
    );
  };

  return (
    <Fragment>
      <Toast
        autohide
        style={{ backgroundColor: '#454545', color: '#ffffff', position: 'absolute', top: 75, right: '45%' }}
        show={toastVisible}
        onClose={() => setToastVisible(!toastVisible)}>
        <Toast.Body>PO Updated!</Toast.Body>
      </Toast>

      <div className='ml-2 mr-2'>
        <form id='poForm' onSubmit={onSubmit}>
          <div className='row justify-content-end'>
            <div className='col-md-8'>
              <h1 className='m-2'>PO Form</h1>
            </div>

            <div className='col-md-4'>
              <div className='form-inline float-right'>
                <Button disabled variant='secondary' className='form-control mr-2'>
                  <strong>Created: {new Date(getValues('timestamp').toString()).toLocaleDateString()}</strong>
                </Button>
                <select
                  placeholder='...'
                  className='form-control mr-2'
                  {...register('status')}
                  onChange={(e) => setComment(`Purchase Order ${e.target.value}`)}>
                  <option key={1} value='Pending'>
                    Pending
                  </option>
                  {isAdmin() && (
                    <>
                      <option key={2} value='Approved'>
                        Approved
                      </option>
                      <option key={3} value='Rejected'>
                        Rejected
                      </option>
                      <option key={4} value='Completed'>
                        Completed
                      </option>
                    </>
                  )}
                </select>

                <Button type='submit' variant='info' className='mr-2 float-right' onClick={onSubmit}>
                  {submit && <Spinner className='mr-1' as='span' animation='border' size='sm' role='status' aria-hidden='true' />}
                  Update
                </Button>
                <Button variant='primary' href='/purchaseOrders'>
                  Close
                </Button>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-9'>
              <h5 className='ml-2'>Use this form to submit PO requests for OIT purchases.</h5>
              <h5 className='ml-2'>Approval will be handled and submitted as soon as possible by Jack Martin or Mike Tarquinio</h5>
              <h5 className='ml-2'>Upon approval, a handler will provide a PO number</h5>
              <br />
            </div>
          </div>

          {/*  Main Row 1 */}
          <div className='row justify-content-start'>
            <div className='col-md-9'>
              <div className='row'>
                <div className='col-sm-3'>
                  <div className='form-group'>
                    <h5>
                      Email&nbsp;
                      <span style={{ color: 'red' }}>
                        <sup>*</sup>
                      </span>
                    </h5>
                    <input
                      className='form-control'
                      {...register('submittedBy', {
                        required: true,
                      })}
                    />
                    <ErrorMessage errors={errors} name='submittedBy' render={({ message }) => <p style={{ color: 'red' }}>Email is required!</p>} />
                  </div>
                </div>

                <div className='col-sm-3'>
                  <div className='form-group'>
                    <h5>Vendor Name</h5>
                    <input className='form-control' {...register('vendorName')} />
                    <ErrorMessage
                      errors={errors}
                      name='vendorName'
                      render={({ message }) => <p style={{ color: 'red' }}>Vendor Name is required!</p>}
                    />
                  </div>
                </div>
                <div className='col-sm-3'>
                  <div className='form-group'>
                    <h5>Vendor Address</h5>
                    <input className='form-control' {...register('vendorAddress')} />
                    <ErrorMessage errors={errors} name='vendorAddress' render={({ message }) => <p style={{ color: 'red' }}>Invalid address!</p>} />
                  </div>
                </div>
                <div className='col-sm-3'>
                  <div className='form-group'>
                    <h5>PO Number</h5>
                    <input className='form-control' {...register('poNumber')} />
                    <ErrorMessage errors={errors} name='poNumber' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
                  </div>
                </div>
              </div>
            </div>

            <div className='col-md-3'>
              <div className='form-group'>
                <h5>
                  Date Required&nbsp;
                  <span style={{ color: 'red' }}>
                    <sup>*</sup>
                  </span>
                </h5>
                <Controller
                  control={control}
                  name='dateRequired'
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <DatePicker
                      // disabled={getValues('dateRequired') !== '' || getValues('dateRequired') !== null}
                      openToDate={new Date()}
                      className='form-control col-sm'
                      selected={value ? new Date(value) : value}
                      onChange={onChange}
                      icon='calendar'
                    />
                  )}
                />
                <ErrorMessage errors={errors} name='dateRequired' render={({ message }) => <p style={{ color: 'red' }}>Date required!</p>} />
              </div>
            </div>
          </div>

          {/* Main Row 2 */}
          <div className='row justify-content-start'>
            <div className='col-md-9'>
              <div className='row'>
                <div className='col-sm-3'>
                  <div className='form-group'>
                    <h5>
                      Dollar Amount&nbsp;
                      <span style={{ color: 'red' }}>
                        <sup>*</sup>
                      </span>
                    </h5>
                    <Controller
                      name={'dollarAmount'}
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, name, value } }) => (
                        <NumericFormat
                          className='form-control'
                          thousandSeparator={true}
                          allowNegative={false}
                          prefix={'$ '}
                          onValueChange={(v) => {
                            onChange(v.floatValue);
                          }}
                          value={value}
                        />
                      )}
                    />
                    <ErrorMessage
                      errors={errors}
                      name='dollarAmount'
                      render={({ message }) => {
                        return <p style={{ color: 'red' }}>Dollar Amount is required!</p>;
                      }}
                    />
                  </div>
                </div>
                <div className='col-sm-3'>
                  <div className='form-group'>
                    <Tooltip tooltipLabel='For Delivery, if applicable'>
                      <h5>
                        Location
                        <span>
                          <sup>?</sup>
                        </span>
                      </h5>
                    </Tooltip>

                    <Controller
                      control={control}
                      name='location'
                      render={({ field: { onChange, value } }) => (
                        <Typeahead
                          id='location'
                          options={locations}
                          placeholder='Choose location'
                          selected={value}
                          highlightOnlyResult
                          onChange={onChange}
                          clearButton
                        />
                      )}
                    />
                    <ErrorMessage errors={errors} name='location' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
                  </div>
                </div>

                <div className='col-sm-3'>
                  <div className='form-group'>
                    {/* <div className='form-inline'> */}
                    <Tooltip tooltipLabel='Will this increase future year operating? Please indicate which year(s)'>
                      <h5>
                        Impacted Operating Budget
                        <span>
                          <sup>?</sup>
                        </span>
                      </h5>
                    </Tooltip>

                    {/* </div> */}
                    <Controller
                      control={control}
                      name='impactedOperatingBudget'
                      render={({ field: { onChange, value } }) => (
                        <Typeahead
                          id='impactedOperatingBudget'
                          options={impactedOperatingBudgets}
                          // labelKey='budget'
                          clearButton
                          placeholder='Select year(s) from dropdown'
                          highlightOnlyResult
                          onChange={onChange}
                          // selected={value.split(',')}
                          selected={value}
                          multiple
                        />
                      )}
                    />
                    <ErrorMessage
                      errors={errors}
                      name='impactedOperatingBudget'
                      render={({ message }) => <p style={{ color: 'red' }}>{message}</p>}
                    />
                  </div>
                </div>
                <div className='col-sm-3'>
                  <div className='form-group'>
                    <h5>Agreement Number</h5>
                    <input className='form-control' {...register('agreementNo')} />
                    <ErrorMessage errors={errors} name='agreementNo' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-3'>
              <div className='form-group'>
                <h5>Date Initiated</h5>
                <Controller
                  control={control}
                  name='dateInitiated'
                  render={({ field: { onChange, value } }) => (
                    <DatePicker
                      // disabled={getValues('dateRequired') !== '' || getValues('dateRequired') !== null}
                      openToDate={new Date()}
                      className='form-control col-sm'
                      selected={value ? new Date(value) : value}
                      onChange={onChange}
                      icon='calendar'
                    />
                  )}
                />
                <ErrorMessage errors={errors} name='dateInitiated' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
              </div>
            </div>
          </div>

          {/* Main Row 3 */}
          <div className='row'>
            <div className='col-md-9'>
              <div className='row justify-content-start'>
                <div className='col-sm-3'>
                  <div className='form-group'>
                    <Tooltip tooltipLabel='Enumerate the impact to listed budget'>
                      <h5>
                        Budget Impact Amount
                        <span>
                          <sup>?</sup>
                        </span>
                      </h5>
                    </Tooltip>

                    <Controller
                      name={'budgetImpactAmount'}
                      control={control}
                      render={({ field: { onChange, name, value } }) => (
                        <NumericFormat
                          className='form-control'
                          thousandSeparator={true}
                          allowNegative={false}
                          prefix={'$ '}
                          onValueChange={(v) => {
                            onChange(v.floatValue);
                          }}
                          value={value}
                        />
                      )}
                    />
                    <ErrorMessage
                      errors={errors}
                      name='budgetImpactAmount'
                      render={({ message }) => {
                        return <p style={{ color: 'red' }}>Invalid value!</p>;
                      }}
                    />
                  </div>
                </div>
                <div className='col-sm-3'>
                  <div className='form-group'>
                    <h5>Budget Account Number</h5>

                    <Controller
                      control={control}
                      name='budgetAccountNo'
                      rules={{ validate: (v) => v !== -1 }}
                      render={({ field: { onChange, value } }) => (
                        <Typeahead
                          id='budgetAccountNo'
                          options={budgetAccounts}
                          placeholder='Choose (Select Unknown if number unknown)'
                          // labelKey=''

                          // defaultInputValue={value}
                          selected={value}
                          highlightOnlyResult
                          onChange={onChange}
                          clearButton
                        />
                      )}
                    />
                    <ErrorMessage errors={errors} name='budgetAccountNumber' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
                  </div>
                </div>
                <div className='col-sm-3'>
                  <div className='form-group'>
                    <h5>
                      Item Being Purchased&nbsp;
                      <span style={{ color: 'red' }}>
                        <sup>*</sup>
                      </span>
                    </h5>
                    <input
                      className='form-control'
                      {...register('itemBeingPurchased', {
                        required: true,
                      })}
                    />
                    <ErrorMessage
                      errors={errors}
                      name='itemBeingPurchased'
                      render={({ message }) => <p style={{ color: 'red' }}>Item Being Purchased is required!</p>}
                    />
                  </div>
                </div>
                <div className='col-sm-3'>
                  <div className='form-group'>
                    <h5>Requisition Number</h5>
                    <input className='form-control' {...register('requisitionNumber')} />
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-3'>
              {/* Placeholder if required later on  */}
              {/* <div className='form-group'>
                <h5>Date Services Received</h5>
                <Controller
                  control={control}
                  name='dateServicesReceived'
                  render={({ field: { onChange, value } }) => (
                    <DatePicker
                      // disabled={getValues('dateRequired') !== '' || getValues('dateRequired') !== null}
                      openToDate={new Date()}
                      className='form-control col-sm'
                      selected={value ? new Date(value) : value}
                      onChange={onChange}
                      icon='calendar'
                    />
                  )}
                />
                <ErrorMessage errors={errors} name='dateServicesReceived' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
              </div> */}
            </div>
          </div>
          {/* Main Row 4 */}
          <div className='row justify-content-start'>
            <div className='col-md-9'>
              <div className='row'>
                <div className='col-sm-1'>
                  <div className='form-group'>
                    <h5>
                      Renewal?&nbsp;
                      <span style={{ color: 'red' }}>
                        <sup>*</sup>
                      </span>
                    </h5>
                    <Controller
                      control={control}
                      name='renewal'
                      render={({ field: { onChange, value } }) => (
                        <FormCheck
                          type='switch'
                          id='renewal'
                          checked={value}
                          onChange={(e) => {
                            console.log('event: ', e);
                            onChange(e);
                          }}
                        />
                      )}
                    />
                    <ErrorMessage errors={errors} name='renewal' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
                  </div>
                </div>
                <div className='col-sm-2'>
                  <div className='form-group'>
                    <h5>For Public Safety?</h5>
                    <Controller
                      control={control}
                      name='forPublicSafety'
                      render={({ field: { onChange, value } }) => (
                        <FormCheck type='switch' id='forPublicSafety' checked={value} onChange={onChange} />
                      )}
                    />
                    <ErrorMessage errors={errors} name='forPublicSafety' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
                  </div>
                </div>
                <div className='col-sm-2'>
                  <div className='form-group'>
                    <NewAttachment poId={getValues().id} />
                  </div>
                </div>
                {getValues().quote !== null && getValues().quote !== '' && <AttachmentList files={getValues().quote} />}
              </div>
            </div>
            <div className='col-md-3'></div>
          </div>
          {/* Main Row 5 */}
          <div className='row justify-content-start'>
            <div className='col-md-9'>
              <div className='row'>
                <div className='col-sm-6'>
                  <div className='form-group'>
                    <h5>Additional Information</h5>
                    <h6>This field can be used to include any additional infomation necessary for the PO.</h6>
                    <h6>Links to G Drive folders containing multiple attachments.</h6>
                    <h6>Hardware/software requests</h6>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className='form-group'>
                    <h5>Support Staff</h5>
                    <select
                      placeholder='...'
                      className='form-control'
                      {...register('supportStaff')}
                      style={{
                        backgroundColor: supportStaff.filter((item) => {
                          if (!watch('supportStaff')) return item.email === '';
                          return item.email === watch('supportStaff');
                        })[0].color,
                      }}>
                      {supportStaff.map((value) => {
                        if (value.email === 'itstee00@aacounty.org') {
                          return (
                            <option disabled key={value.email} value={value.email} style={{ backgroundColor: value.color }}>
                              {value.name}
                            </option>
                          );
                        }
                        return (
                          <option key={value.email} value={value.email} style={{ backgroundColor: value.color }}>
                            {value.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className='form-group'>
                    <h5>Approver</h5>
                    <select placeholder='...' className='form-control' {...register('approver')}>
                      {approvalStaff.map((value) => {
                        return <option value={value.email}>{value.name}</option>;
                      })}
                    </select>
                    <ErrorMessage errors={errors} name='approver' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-3'>
              <div className='form-group'>
                <h5>Add Comment</h5>
                <textarea className='form-control col-md' id='comment' rows={1} value={comment} onChange={(e) => setComment(e.target.value)} />
              </div>
            </div>
          </div>
          {/* Main Row 6 */}
          <div className='row justify-content-start'>
            <div className='col-md-9'>
              <div className='row '>
                <div className='col-md-6'>
                  <h5>&nbsp;</h5>
                  <textarea className='form-control' {...register('additionalInfo')} />
                  <ErrorMessage errors={errors} name='additionalInfo' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
                </div>
                <div className='col-md-6'>
                  <h5>Support Staff Notes</h5>
                  <textarea className='form-control' {...register('notes')} />
                  <ErrorMessage errors={errors} name='notes' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
                </div>
              </div>
            </div>
            <div className='col-md-3'>
              <h5>&nbsp;</h5>
              <Comments po={getValues().id} />
            </div>
          </div>
        </form>
      </div>
    </Fragment>
  );
};
